import merge from 'lodash/merge'
import once from 'lodash/once'

import { getGoogleAdWordKey, getGoogleAnalyticsKey } from '../services/Env'
import { loadScript } from '../utils'

declare global {
  interface Window {
    gtag: (event: string, action: string, data?: object) => void
    dataLayer: Array<{ [key: string]: any }>
  }
}

const GoogleTag = {
  initialize: once(() => {
    const googleAnalyticsKey = getGoogleAnalyticsKey()
    const googleAdWordId = getGoogleAdWordKey()

    if (!googleAnalyticsKey) {
      return
    }

    loadScript(`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsKey}`, '', true)

    window.dataLayer = window.dataLayer || []

    window.gtag = function () {
      window.dataLayer.push(arguments)
    }

    // @ts-ignore
    window.gtag('js', new Date())

    window.gtag('config', googleAnalyticsKey)

    if (googleAdWordId) {
      window.gtag('config', googleAdWordId)
    }
  }),

  track(
    category: string,
    action: string,
    data: { label?: string } | { send_to?: string; value: number; currency?: string },
  ) {
    if (!window.gtag) {
      return
    }

    const baseObject = {
      event_category: category,
    }

    merge(baseObject, isLabel(data) ? { event_label: data.label } : data)

    window.gtag('event', action, baseObject)
  },
}

function isLabel(input: any): input is { label: string } {
  return input.label
}

export default GoogleTag
